import session from "@/api/session";

export default {
  getLeadByID(id) {
    return session.get(`/leads/${id}/`);
  },
  getDealStagesById(id) {
    return session.get(`/hubspot/pipelines/deals/${id}/`);
  },
  getLeadAuditByID(id,config) {
    return session.get(`/leads/${id}/audit/?order=desc&page=${config.paginationPage}&limit=${config.paginationLimit}`);
  },
  getPartnerByID(id) {
    return session.get(`/partners/${id}/`);
  },
  getAllTariffs() {
    return session.get(`/pricing/tariffs/`);
  },
  getLeadStaticData(params) {
    return session.get('/static-data/options/', {params});
  },
  getLeadQuoteByID(id) {
    return session.get(`/products/${id}/quotation/`);
  },
  sendLeadQuoteByID(id) {
    return session.post(`/products/${id}/quotation/`);
  },
  createBillingAccount(id,data) {
    return session.post(`/leads/${id}/actions/create-billing-account/`,JSON.stringify(data));
  },
  updateLead(id,data) {
    return session.patch(`/leads/${id}/`,JSON.stringify(data));
  },
  sendDDMandate(id) {
    return session.post(`/accounts/${id}/actions/dd-mandate/`);
  },
  sendSmsApi(id,data) {
    return session.post(`/leads/${id}/actions/send-sms/`,JSON.stringify(data));
  },
  attachToAccount(id, account_id) {
    return session.post(`/leads/${id}/actions/attach-to-account/${account_id}/`);
  }
};
